// Overriding default of 75 to flush old image cache.  Do not change it back to 75 or 74
// unless you're ready to manually change every single storyblok image or solve it some other way
export const DEFAULT_IMAGE_QUALITY = 70
